const Data = {
  apiEndPoint: process.env.REACT_APP_API_URL,
  chatEndPoint: process.env.REACT_APP_CHAT_URL,
  name: process.env.NODE_ENV,
  rootuser: process.env.REACT_APP_ROOT_USER,
  dashboardURL: process.env.REACT_APP_POWERBI,
  form_auth: process.env.REACT_APP_FORM_AUTH === 'yes' || false,
  sso_auth: process.env.REACT_APP_SSO_AUTH === 'yes' || false,
};

export default Data;
